import Aura from '@primevue/themes/aura';
import { definePreset } from '@primevue/themes';

export const AppPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          color: 'hsl(213, 100%, 48%)',
          inverseColor: 'hsl(213, 100%, 48%)',
          hoverColor: 'hsl(213, 100%, 48%)',
          activeColor: 'hsl(213, 100%, 48%)'
        },
        highlight: {
          background: 'hsl(213, 100%, 48%, 0.5)',
          focusBackground: 'hsl(213, 100%, 48%, 0.8)',
          color: '{primary.color}',
          focusColor: '#ffffff'
        },
        formField: {
          hoverBorderColor: '{primary.color}'
        }
      }
    }
  }
});
